module.exports = __webpack_public_path__ + "files/5c32afd971dadc1bd9600e0cb921fb6c.png";